import React from 'react'
import { useDispatch, useSelector } from "react-redux"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import routes from "."
import LoginLayout from '../../layouts/LoginLayout'
import MainPageLayout from '../../layouts/MainPageLayout'
import GroupSubjectLogBook from '../../pages/GroupSubjectLogBook'
import LessonLoogbook from '../../pages/LessonLogbook'
import LoginPage from "../../pages/Login"
import MainPage from "../../pages/Main"
import PlansPage from '../../pages/Plans'
import StudentLessonsPage from '../../pages/StudentLessons'
import StudentLogbook from '../../pages/StudentLogbook'
import TimetablePage from '../../pages/Timetable'
import { getUserInfo } from "../../redux/userSlice"
import PrivateRoute from './PrivateRoute'


const RouteList = () => {

    const dispatch = useDispatch()

    React.useEffect(() => { dispatch(getUserInfo()) }, [dispatch])

    const { userInfo } = useSelector(x => x.user)

    return <BrowserRouter>
        <Routes>

            <Route path="*" element={<Navigate to={routes.main.path} />} />

            <Route path={routes.main.path} element={
                <MainPageLayout>
                    <MainPage />
                </MainPageLayout>
            } />

            <Route path={routes.login.path} element={
                <LoginLayout>
                    <LoginPage />
                </LoginLayout>
            } />

            <Route path={routes.lessonLogBook.path} element={
                <PrivateRoute requiredRoles={["учитель"]}>
                    <LessonLoogbook />
                </PrivateRoute>
            } />

            <Route path={routes.groupSubjectLoogBook.path} element={
                <PrivateRoute requiredRoles={["учитель"]}>
                    <GroupSubjectLogBook />
                </PrivateRoute>
            } />

            <Route path={routes.studentLogBook.path} element={
                <PrivateRoute requiredRoles={["ученик", "родитель"]}>
                    <StudentLogbook />
                </PrivateRoute>
            } />

            <Route path={routes.studentLessons.path} element={
                <PrivateRoute requiredRoles={["ученик", "родитель"]}>
                    <StudentLessonsPage canEdit={userInfo?.role?.name === "ученик"} />
                </PrivateRoute>
            } />

            <Route path={routes.timetable.path} element={
                <PrivateRoute requiredRoles={["учитель", "ученик", "родитель"]}>
                    <TimetablePage />
                </PrivateRoute>
            } />

            <Route path={routes.plans.path} element={
                <PrivateRoute requiredRoles={["учитель"]}>
                    <PlansPage />
                </PrivateRoute>
            } />

        </Routes>
    </BrowserRouter>
}

export default RouteList